export const alertsSelector = (state) => state.alerts.alerts;
export const alertsStatusSelector = (state) => state.alerts.alertsStatus;
export const alertsNextPageStatusSelector = (state) =>
  state.alerts.alertsNextPageStatus;
export const newAlertSelector = (state) => state.alerts.newAlert;
